import { apiRequest } from './http'
import type { Owner } from '@/types/domain'

export const authApi = {
  login: (phone: string, password: string) => apiRequest<{ accessToken: string; user: Owner }>('/auth/login', {
    method: 'POST',
    authenticated: false,
    body: { phone, password }
  }),
  me: () => apiRequest<Owner>('/auth/me'),
  logout: () => apiRequest<null>('/auth/logout', { method: 'POST' })
}
